<template lang="pug">
    .text-sm(class="mt-10 1024:mt-20 mb-2")
        slot
</template>

<script>
export default {
    name: "TextBlock",
}
</script>